import React from 'react';
import { Button, Form, Input, InputNumber, Spin } from 'antd';

const CreateEquipmentForm = (props) => {
    const { form, successHandler, submitButtonText, loading } = props;

    const onFinish = (values) => {
        successHandler({
            title: values.title,
            count: values.count,
            description: values.description,
        });
    };
    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    const initialValues = {
        title: '',
        count: 1,
        description: '',
    };

    return (
        <Spin spinning={loading}>
            <Form
                form={form}
                labelCol={{
                    span: 8,
                }}
                wrapperCol={{
                    span: 16,
                }}
                style={{
                    maxWidth: 600,
                }}
                autoComplete="off"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                initialValues={initialValues}
            >
                <Form.Item
                    label="Nazwa sprzętu"
                    name="title"
                    rules={[
                        {
                            required: true,
                            message: 'Proszę dodać sprzęt!',
                        },
                    ]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="Ilość"
                    name="count"
                    rules={[
                        {
                            required: true,
                            message: 'Proszę podać ilość sprzętu!',
                        },
                    ]}
                >
                    <InputNumber min={1} max={1000} />
                </Form.Item>

                <Form.Item name="description" label="Opis" max={300}>
                    <Input.TextArea />
                </Form.Item>

                <Form.Item
                    wrapperCol={{
                        offset: 8,
                        span: 16,
                    }}
                >
                    <Button type="primary" htmlType="submit" loading={loading}>
                        {submitButtonText}
                    </Button>
                </Form.Item>
            </Form>
        </Spin>
    );
};
export default CreateEquipmentForm;
